export const RequiredAsterisk = () => (
  <span className="text-destructive" aria-hidden="true">
    *
  </span>
);
